import { Button, Popconfirm } from 'antd';
import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';

interface UnshareDocumentButtonProps {
    onClick: () => void;
    title?: string;
    description?: string;
    label?: string;
}

export const UnshareDocumentButton: React.FC<UnshareDocumentButtonProps> = ({
    onClick,
    title = 'Are you sure to stop sharing?',
    description = 'Stop sharing for resource',
    label,
}) => {
    return (
        <Popconfirm
            placement="topRight"
            title={title}
            description={description}
            onConfirm={(event) => {
                event?.stopPropagation();
                onClick();
            }}
            onCancel={(event) => {
                event?.stopPropagation();
            }}
            okText="Yes"
            cancelText="No"
        >
            <Button
                onClick={(event) => {
                    event.stopPropagation();
                }}
                type="text"
                size={'small'}
                icon={<CloseCircleOutlined style={{ fontSize: 16, color: '#616161' }} />}
            >
                {label}
            </Button>
        </Popconfirm>
    );
};
